import React from "react";
import { motion } from "framer-motion";

const ContactPage = () => {
  return (
    <motion.div
      initial={{ x: 1000 }}
      animate={{ x: 0 }}
      transition={{ duration: 0.5, ease: "linear" }}
      className="my-10 flex justify-center items-center flex-col gap-10"
    >
      <div className="">
        <h1 className="text-4xl text-gray-700 font-bold text-center">
          Contact Us
        </h1>
        <p className="text-gray-500 tracking-widest mt-3">
          Buy Online & We Deliver
        </p>
      </div>
      {/* <div className="flex gap-10">
        <div className="hidden md:block mockup-phone mx-auto">
          <div className="camera"></div>
          <div className="display">
            <div className="artboard artboard-demo phone-1">
              <div className="flex flex-col gap-4 px-5">
                <div className="flex flex-col gap-2 border p-5 rounded-xl shadow-lg">
                  <h1 className="text-sm text-gray-700 font-bold italic tracking-widest">
                    Address
                  </h1>
                  <p className="text-xs tracking-wider leading-5 font-semibold text-gray-500">
                    Shop(1)-Building-A-3, Wing C, Star City, Thanlyin Tsp,
                    Yangon, Myanmar
                  </p>
                  <p className="text-xs tracking-wider leading-5 font-semibold text-gray-500">
                    Shop(2)-United Living Mall, No-48, Level-1, Kyaikkasan Road,
                    Tamwe Tsp, Yangon, Myanmar
                  </p>
                </div>
                <div className="flex flex-col gap-2 border p-5 rounded-xl shadow-lg">
                  <h1 className="text-sm text-gray-700 font-bold italic tracking-widest">
                    Phone
                  </h1>
                  <p className="text-xs tracking-wider leading-5 font-semibold text-gray-500">
                    +95-9-898-3333-03
                  </p>
                </div>
                <div className="flex flex-col gap-2 border p-5 rounded-xl shadow-lg">
                  <h1 className="text-sm text-gray-700 font-bold italic tracking-widest">
                    Email
                  </h1>
                  <p className="text-xs tracking-wider leading-5 font-semibold text-gray-500">
                    nextgadgetshop@gmail.com
                  </p>
                </div>
                <div className="flex gap-2 mt-3 justify-center">
                  <AiFillInstagram className="text-2xl font-semibold text-gray-500 cursor-pointer" />
                  <AiFillFacebook className="text-2xl font-semibold text-gray-500 cursor-pointer" />
                  <AiFillPhone className="text-2xl font-semibold text-gray-500 cursor-pointer" />
                  <AiFillMail className="text-2xl font-semibold text-gray-500 cursor-pointer" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-5 mt-0 md:mt-10">
          <div className="flex flex-col gap-2 border p-5 rounded-xl shadow-lg">
            <h1 className="text-lg text-gray-700 font-bold italic tracking-widest">
              Address
            </h1>
            <p className="text-sm tracking-wider leading-5 font-semibold text-gray-500">
              Shop(1)-Building-A-3, Wing C, Star City, Thanlyin Tsp, Yangon,
              Myanmar
            </p>
            <p className="text-sm tracking-wider leading-5 font-semibold text-gray-500">
              Shop(2)-United Living Mall, No-48, Level-1, Kyaikkasan Road, Tamwe
              Tsp, Yangon, Myanmar
            </p>
          </div>
          <div className="flex flex-col gap-2 border p-5 rounded-xl shadow-lg">
            <h1 className="text-lg text-gray-700 font-bold italic tracking-widest">
              Phone
            </h1>
            <p className="text-sm tracking-wider leading-5 font-semibold text-gray-500">
              +95-9-898-3333-03
            </p>
          </div>
          <div className="flex flex-col gap-2 border p-5 rounded-xl shadow-lg">
            <h1 className="text-lg text-gray-700 font-bold italic tracking-widest">
              Email
            </h1>
            <p className="text-sm tracking-wider leading-5 font-semibold text-gray-500">
              nextgadgetshop@gmail.com
            </p>
          </div>
        </div>
      </div> */}
      <div className="flex flex-col gap-5">
        <div className="flex flex-col gap-2 border p-5 rounded-xl shadow-lg">
          <h1 className="text-lg text-gray-700 font-bold italic tracking-widest">
            Address
          </h1>
          <p className="text-sm tracking-wider leading-5 font-semibold text-gray-500">
            Shop(1)-Building-A-3, Wing C, Star City, Thanlyin Tsp, Yangon,
            Myanmar
          </p>
          <p className="text-sm tracking-wider leading-5 font-semibold text-gray-500">
            Shop(2)-United Living Mall, No-48, Level-1, Kyaikkasan Road, Tamwe
            Tsp, Yangon, Myanmar
          </p>
        </div>
        <div className="flex flex-col gap-2 border p-5 rounded-xl shadow-lg">
          <h1 className="text-lg text-gray-700 font-bold italic tracking-widest">
            Phone
          </h1>
          <p className="text-sm tracking-wider leading-5 font-semibold text-gray-500">
            +95-9-898-3333-03
          </p>
        </div>
        <div className="flex flex-col gap-2 border p-5 rounded-xl shadow-lg">
          <h1 className="text-lg text-gray-700 font-bold italic tracking-widest">
            Email
          </h1>
          <p className="text-sm tracking-wider leading-5 font-semibold text-gray-500">
            nextgadgetshop@gmail.com
          </p>
        </div>
      </div>
    </motion.div>
  );
};

export default ContactPage;
